import {
  type OfferV11,
  type SellerPromotionV2,
} from '@redteclab/api/clients/bully'

import { type BestOffer } from '../../../algolia'

export const productAccessorGetSellerPromotionFromOffer = (
  offer: OfferV11 | BestOffer,
): SellerPromotionV2 | undefined => {
  const isOfferV11 = (
    currentOffer: OfferV11 | BestOffer,
  ): currentOffer is OfferV11 => {
    return 'sellerPromotionV2' in currentOffer
  }

  if (isOfferV11(offer)) {
    return offer.sellerPromotionV2 ?? undefined
  }

  return offer.seller_promotion ?? undefined
}
